<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-form
          :model="formData"
          ref="ruleForm"
          :rules="rules"
          label-width="100px"
          class="demo-ruleForm"
      >
        <div v-for="(subject,index) in row.subject_list ">
          <el-divider>项目信息{{ index + 1 }}</el-divider>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="项目" prop="name">
                <el-input
                    disabled
                    type="text"
                    placeholder="请输入单位名称"
                    v-model="subject.subject_name"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="参赛运动员" prop="type">
                <el-tag
                    v-for="(yundongyuan ,index) in subject.yundongyuan"
                    :key="index"
                    type="primary"
                    style="margin-right: 10px;"
                > {{ yundongyuan.name }} {{ yundongyuan.sex | sex}}
                </el-tag>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="替补运动员" prop="tbydy">
                <el-tag
                    v-for="(yundongyuan ,index) in subject.tbydy"
                    :key="index"
                    type="primary"
                    style="margin-right: 10px;"
                > {{ yundongyuan.name }} {{ yundongyuan.sex | sex}}
                </el-tag>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="自选音乐" prop="grade"  v-if="!subject.music_url">
                <FileUploader :fileList="subject.music" :limit="1" :accept="'.mp3'"></FileUploader>
              </el-form-item>
              <el-form-item label="规定音乐" v-else>
              <div style="cursor: pointer" @click="playMusicUrl=subject.music_url;showMusic=true">点击试听 <i
                  class="el-icon-arrow-right"></i></div>
            </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="教练员" prop="jiaolian">
                <el-tag
                    v-for="(yundongyuan ,index) in subject.jiaolian"
                    :key="index"
                    type="primary"
                    style="margin-right: 10px;"
                > {{ yundongyuan.name }} {{ yundongyuan.sex | sex}}
                </el-tag>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">保存
            </el-button>
            <el-button @click="resetForm('ruleForm')" plain v-if="false">重置</el-button>
          </el-col>
        </el-row>
      </el-form>

      <el-dialog title="音乐播放" :visible.sync="showMusic" @close="showMusic = false">
        <div style="text-align: center">
          <audio autoplay style="margin: 10px auto" v-if="playMusicUrl&&showMusic" :src="playMusicUrl"
                 controls="controls"></audio>
        </div>
      </el-dialog>


    </div>
  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}

.memberResultWrap {
  background: #F3F3F3;
  margin: 0.2rem;
  border-radius: 8px;
  padding: 0.2rem;
}

.memberResultWrap .memberLi {
  font-size: 14px;
  color: #666;
  height: 36px;
  line-height: 36px;
}

.memberResultWrap .memberLi .van-tag {
  width: auto !important;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}

</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import FileUploader from '@/components/picker/FileUploader.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Dialog,
  ActionSheet,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

import SubjectJiaolianPicker from '@/components/picker/SubjectJiaolianPicker.vue';
import YundongyuanPicker from '@/components/picker/YundongyuanPicker.vue';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button).use(Dialog);
export default {
  name: 'SaiApplyFormStep2',
  components: {
    [Field.name]: Field,
    PicUploader,
    FileUploader,
    SubjectJiaolianPicker,
    YundongyuanPicker,
  },
  data: function () {
    return {
      validator,
      playMusicUrl: '',
      showMusic: false,
      thisSubjectIndex: 0,
      saveLoading: false,
      showWxShare: false,
      showSubjectPicker: false,
      showNumTypePicker: false,
      show_share_panel: false,
      numTypeColumns: ['身份证', '护照'],
      showArea: false,
      areaList: {},
      rules: {},
      copy_text: 'cccc',
      areaValue: '',
      submitType: '',
      subject_name: '',
      subjectArray: [],
      subjectOptions: [],
      subjectOptionsAll: [
        {
          name: '幼儿组',
          children: [
            {
              name: '幼儿组',
              children: [{
                name: '舞蹈啦啦操',
                children: [
                  {
                    name: '花球规定动作',
                  },
                  {
                    name: '222',
                  }
                ]
              }, {
                name: '余杭区',
                children: [
                  {
                    name: '111',
                  },
                  {
                    name: '222',
                  }
                ]
              }],
            },
            {
              name: '温州',
              children: [{name: '鹿城区'}, {name: '瓯海区'}],
            },
          ],
        },
        {
          name: '福建',
          children: [
            {
              name: '福州',
              children: [{name: '鼓楼区'}, {name: '台江区'}],
            },
            {
              name: '厦门',
              children: [{name: '思明区'}, {name: '海沧区'}],
            },
          ],
        },
      ],
      row: {
        subject_list: [],
        subject_options: [],
      },
      formData: {
        id: 0,
        saiqu_name: 'xxxxx',
        danwei: 'xxxxx',
        caipan: [],
        music: [],
        yundongyuan: [],
        tbydy: [],
        jiaolian: [],
        areas: '',
        province: '',
        city: '',
        county: '',
        kaojitype: '考级中心',
        changdipic: [{
          "uid": "vc-upload-1587109262602680",
          "url": "https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg",
          "name": "支付宝.jpg",
          "save_name": "h5/2020-04-17/1587109262602680.jpg"
        }],
        zhizhaopic: [{
          "uid": "vc-upload-1587109262602680",
          "url": "https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg",
          "name": "支付宝.jpg",
          "save_name": "h5/2020-04-17/1587109262602680.jpg"
        }],
      },
    }
  },
  mounted() {
    let that = this;
    that.areaList = area;
    that.formData.id = this.$route.query.id;
    document.title = '选择音乐';
    if (that.formData.id) {
      this.fetch();
    }
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  filters: {
    sex: function (val) {
      switch (val) {
        case 1 :
          return '男';
        case 2 :
          return '女';
        default :
          return ''
      }
    }
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },
    subjectAdd() {
      this.row.subject_list.push({
        showYundongyuanPicker: false,
        showTbYundongyuanPicker: false,
        showJiaolianPicker: false,
        subject_name: '',
        subjectArray: [],
        yundongyuan: [],
        tbydy: [],
        music: [],
        jiaolian: [],
      })
    },
    subjectRemove(item, index) {
      let that = this;
      let notice = '确认删除项目' + (item.subject_name ? '(' + item.subject_name + ')' : '') + '吗?';
      Dialog.confirm({
        title: '确认',
        message: notice
      })
          .then(() => {
            // on confirm
            console.log('subjectRemove');

            if (!item.id) {
              that.row.subject_list.splice(index, 1);
              return
            }

            that.$api.post('/api/isai/subjectDelete', {
              'baoming_id': that.row.id,
              'subject_id': item.id
            }, (res) => {

              that.row.subject_list.splice(index, 1);
            }, (res) => {
              Toast.fail(res.msg);
            })

          })
          .catch(() => {
            // on cancel
          });
    },

    submitForm(formName) {
      const that = this;
      // 拿到地区的 省市区名称

      let valiOk = true;
      that.row.subject_list.map((item,index) =>{
        if(!item.music_url  && item.music.length==0){
          this.$message.warning('请上传项目'+(index+1)+'的自选音乐');
          valiOk = false;
          return ;
        }
      });
      if(!valiOk){
        return ;
      }

      that.$refs[formName].validate((valid) => {
        if (valid) {

          that.saveLoading = true;
          that.$api.post('/api/isai/musicsave', {
            'baoming_id' : that.row.id,
            'subject_list' :JSON.stringify( that.row.subject_list.map(item =>{
              return {
                'id' : item.id ,
                'music' : item.music,
              }
            }))
          }, (res) => {
            that.$message.success('保存成功')
            that.saveLoading = false;
          }, (rs) => {
            that.$message.error(rs.msg)
            that.saveLoading = false;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    openSubjectPicker(option, index) {
      this.showSubjectPicker = true;
      this.thisSubjectIndex = index;
      this.subjectOptions = option;

      this.row.subject_list[this.thisSubjectIndex].subject = undefined;
      this.row.subject_list[this.thisSubjectIndex].subjectArray = [];
      this.row.subject_list[this.thisSubjectIndex].subject_name = '';
    },
    onSubjectClose() {
      this.showSubjectPicker = false;
      this.row.subject_list[this.thisSubjectIndex].subject = undefined;
      this.row.subject_list[this.thisSubjectIndex].subjectArray = [];
      this.row.subject_list[this.thisSubjectIndex].subject_name = '';
    },
    onSubjectSelect(item) {
      console.log(item);
      this.row.subject_list[this.thisSubjectIndex].subjectArray.push(item);
      this.row.subject_list[this.thisSubjectIndex].subject_name = this.row.subject_list[this.thisSubjectIndex].subjectArray.map(item => {
        return item.name
      }).join('-')
      if (!item.children || item.children.length == 0) {
        this.showSubjectPicker = false;
        this.onShowMusic();
        return false;
      }
      this.subjectOptions = item.children;
    },
    onShowMusic() {
      let item = this.row.subject_list[this.thisSubjectIndex];
      let subject = item.subjectArray[item.subjectArray.length - 1].key
      let that = this;
      console.log('onShowMusic', subject);
      that.$api.post('/api/isai/getSubjectMusic', {
        subject: subject
      }, (res) => {
        console.log(res);
        that.$set(this.row.subject_list[this.thisSubjectIndex], 'music_url', res.data.music_url);
      }, (res) => {
        console.log(res);
        that.$set(this.row.subject_list[this.thisSubjectIndex], 'music_url', '');
      });
    },
    onYundongyuanConfirm(values) {
      console.log('onYundongyuanConfirm', values)
//                this.showYundongyuanPicker = false;
      this.row.subject_list[this.thisSubjectIndex].showYundongyuanPicker = false;
      this.row.subject_list[this.thisSubjectIndex].yundongyuan = [...values];
    },
    onYundongyuanChange(values) {
      console.log('onYundongyaunChange', values)
      this.row.subject_list[this.thisSubjectIndex].yundongyuan = [...values];
    },
    onTbYundongyuanConfirm(values) {
      console.log('onTbYundongyuanConfirm', values)
      this.row.subject_list[this.thisSubjectIndex].showTbYundongyuanPicker = false;
      this.row.subject_list[this.thisSubjectIndex].tbydy = [...values];
    },
    onTbYundongyuanChange(values) {
      console.log('onTbYundongyuanChange', values)
      this.row.subject_list[this.thisSubjectIndex].tbydy = [...values];
    },
    onJiaolianConfirm(values) {
      console.log('onJiaolianConfirm', values)
      this.row.subject_list[this.thisSubjectIndex].showJiaolianPicker = false;
      this.row.subject_list[this.thisSubjectIndex].jiaolian = [...values];
    },
    onJiaolianChange(values) {
      console.log('onJiaolianChange', values)
      this.row.subject_list[this.thisSubjectIndex].jiaolian = [...values];
    },
    onNumTypeConfirm(value, index) {
      this.row.subject_list[this.thisSubjectIndex].numTypeName = value;
      this.row.subject_list[this.thisSubjectIndex].numtype = index + 1;
      this.showNumTypePicker = false;
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {

      }
      let valiOk = true;

      that.row.subject_list.map((item, index) => {
        if (!item.music_url && item.music.length == 0) {
          Toast('请上传项目' + (index + 1) + '的自选音乐');
          valiOk = false;
          return;
        }
      });
      if (!valiOk) {
        return;
      }


      that.saveLoading = true;

      that.$api.post('/api/isai/musicsave', {
        'baoming_id': that.row.id,
        'subject_list': JSON.stringify(that.row.subject_list.map(item => {
          return {
            'id': item.id,
            'music': item.music,
          }
        }))
      }, (res) => {
        Toast('保存成功');
        that.saveLoading = false;
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
    },
    fetch() {
      let that = this;
      that.$api.post('/api/isai/step2detail', {
        id: that.formData.id
      }, (res) => {
        that.row = res.data;
        that.subjectOptionsAll = res.data.subject_options;
        that.copy_text = res.data.share_data.url;
        //showYundongyuanPicker
        that.row.subject_list.map(item => {
          that.$set(item, 'subjectArray', []);
          that.$set(item, 'showYundongyuanPicker', false);
          that.$set(item, 'showTbYundongyuanPicker', false);
          that.$set(item, 'showJiaolianPicker', false);
          that.$set(item, 'music_url', item.subject_music.music_url ? item.subject_music.music_url : '');
        });

        that.wxShare(that.row.share_data.title, that.row.share_data.desc, that.row.share_data.url, that.row.share_data.pic_url);
      }, (res) => {
        Toast.fail(res.msg);
      })
    },


    shareWeixinFriend() {
      console.log('shareWeixinFriend')
      let that = this;
      if (window.isApp()) {
        appEvent({
          name: 'shareWeixinFriend',
          query: that.row.share_data
        });
      } else {
        this.showWxShare = true;
        this.show_share_panel = false;
      }
    },
    shareWeixinTimeLine() {
      let that = this;
      if (window.isApp()) {
        appEvent({
          name: 'shareWeixinTimeLine',
          query: that.row.share_data
        });
      } else {
        this.showWxShare = true;
        this.show_share_panel = false;

      }
    }

  }
}
</script>



// WEBPACK FOOTER //
// SaiApplyFormStep2Music.vue?0a4b7492